import moment from 'moment'

import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import {
  setPatientEventsReport,
  setPatientEventsReportLoading
} from 'src/store/modules/reports'

import {
  DATE_TIME_FORMAT_FOR_SERVER,
  EXPORT_PATIENT_EVENTS_REPORT,
  GET_PATIENT_EVENTS_REPORT
} from 'src/constants'
import { exportReport } from 'src/utils/Functions'

export const getPatientEventsReport =
  (config = {}) =>
  async (dispatch) => {
    const { params = {}, query = {} } = config

    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_PATIENT_EVENTS_REPORT,
          params,
          query
        }
      })

      dispatch(setPatientEventsReport(items))

      return meta
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const exportPatientEventsReport =
  (config = {}) =>
  async (dispatch) => {
    dispatch(setPatientEventsReportLoading(true))

    const updConfig = {
      pathname: EXPORT_PATIENT_EVENTS_REPORT,
      ...config
    }
    const fileNameDefault = `patient_events_report_${moment().format(
      DATE_TIME_FORMAT_FOR_SERVER
    )}.xls`

    await exportReport(updConfig, fileNameDefault)

    dispatch(setPatientEventsReportLoading(false))
  }
